import { useEffect, useState } from "react";

import { imageUrl } from "../lib/images";
import { useLanguage } from "../i18n/LanguageContext";
import "./Lightbox.css";

/**
 * Click any photograph on the site and it opens full-screen at high
 * resolution. One global listener, so pages need no wiring: anything inside
 * a `.photo` box counts, except the hero.
 */
export default function Lightbox() {
  const { t } = useLanguage();
  const [open, setOpen] = useState<{ src: string; alt: string } | null>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      const img = target?.closest?.(".photo img") as HTMLImageElement | null;
      if (!img || img.closest(".hero")) return;
      e.preventDefault();
      e.stopPropagation();
      setOpen({ src: imageUrl(img.currentSrc || img.src, 2000), alt: img.alt || "" });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(null); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;
  return (
    <div
      className="lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={open.alt || "Foto"}
      onClick={() => setOpen(null)}
    >
      <img src={open.src} alt={open.alt} onClick={(e) => e.stopPropagation()} />
      <button className="lightbox-close" onClick={() => setOpen(null)} aria-label={t("close")}>✕</button>
    </div>
  );
}
